export enum CurrencyEnum {
  AMD = 'AMD',
  USD = 'USD',
  EUR = 'EUR',
}

export type Currency = keyof typeof CurrencyEnum;
